<template>
  <div class="pcd-detail-header">
    <vxe-form
        ref="payForm"
        class="pay-form"
        title-align="right"
        title-width="100"
        :data="formData"
        :rules="formRules"
    >
      <vxe-form-item
          title="标题"
          field="instanceName"
          span="8"
      >
        <template>
          <vxe-input
              v-model="formData.instanceName"
              @blur="clearValidate"
              :disabled="!isEdit"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="申请人" field="applyUserName" span="8">
        <template>
          <vxe-input v-model="formData.applyUserName" disabled></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="申请时间" field="applyTime" span="8">
        <template>
          <vxe-input
              v-model="formData.applyTime"
              placeholder="日期选择"
              type="date"
              @blur="clearValidate"
              :disabled="!isEdit"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="所属公司" field="compName" span="8">
        <template>
          <div
              style="display: flex;align-items: center;height: 100%;padding-left: 10px;border-bottom: 1px solid #f2f1f1;">
            <platform-corp
                :row="formData"
                :field="'compName'"
                :placeholder="'请选择平台企业'"
                @update="selectCompName"
                :autoSave="false"
                :isEdit="isEdit && !isOrder"
            ></platform-corp>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="证明人" field="reterence" span="8" class="pcd-peo-down">
        <vxe-pulldown ref="xDown" transfer>
          <template>
            <div v-if="isHasDo && formData.isReterenceEdit" style="display: flex;align-items: center;">
              <a
                  class="sel-link"
                  @click="focusEvent('xDown')"
                  target="_black"
                  style="cursor: pointer"
              >{{ formData.reterence === null || formData.reterence === "" ? "请选择用户" : formData.reterence }}</a>
              <img v-if="formData.reterence" style="height: 10px;width: 10px;cursor: pointer;" src="~assets/images/common/close.png"
                   @click="removeReterence"/>
            </div>
            <span class="sel-link-span" v-else>{{ formData.reterence }}</span>
          </template>
          <template v-slot:dropdown>
            <div class="people-dropdown-x">
              <vxe-input
                  class="searchInput"
                  v-model="filterName"
                  type="search"
                  placeholder="账户名"
                  @keyup.enter.native="search"
                  @search-click="search"
              ></vxe-input>
              <vxe-grid
                  highlight-hover-row
                  auto-resize
                  height="auto"
                  class="table-style"
                  :pager-config="tablePage"
                  :data="tableList"
                  :columns="tableColumn"
                  @cell-click="cellClickEvent"
                  @page-change="pageChange"
              ></vxe-grid>
            </div>
          </template>
        </vxe-pulldown>
      </vxe-form-item>
      <vxe-form-item title="流程编号" field="instanceNum" span="8">
        <template>
          <vxe-input v-model="formData.instanceNum" disabled></vxe-input>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import {isEmpty, isNotEmpty} from "@/utils/util";
import getAuthOrization from "@/mixin/getAuthOrization";
import PlatformCorp from "@/components/common/PlatformCorp";

export default {
  mixins: [getAuthOrization],
  components: {PlatformCorp},
  props: {
    pcdType: Number,
    formDataObj: Object,
    isSubmit: Boolean,
    isEdit: Boolean,
    isChangeType: {
      type: Boolean,
      default: false,
    },
    isLoaded: Boolean,
    isHasDo: {
      type: Boolean,
      default: false,
    },
    isOrder: {
      type: Boolean,
      default: false,
    },
    contractShow: {
      contractShow: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        instanceName: null,
        instanceNum: null,
        applyUserName: null,
        applyTime: null,
        type: 1,
        reterence: null,
        reterenceId: null,
        leader: null,
        leaderId: null,
        manager: null,
        managerId: null,
        payType: 1,
        compName: null,
        isLeaderEdit: null,
        isManagerEdit: null,
        isReterenceEdit: null
      },
      formRules: {
        instanceName: [{required: true, message: "请填写标题"}],
        applyUserName: [{required: true, message: "请填写申请人"}],
        applyTime: [{required: true, message: "请选择时间"}],
        type: [{required: true, message: "请选择类型"}],
        compName: [{required: true, message: "请选择所属公司"}],
        isQqPush: [{required: true, message: "请选择同步企企"}],
      },
      qQOptions: [
        {label: "否", value: 0},
        {label: "是", value: 1}
      ],
      payTypeOptions: [
        {label: "线上支付", value: 0},
        {label: "线下支付", value: 1},
      ],
      CollectionOptions: [
        {label: "线上收款", value: 0},
        {label: "线下收款", value: 1},
      ],
      contractOptions: [
        {label: "自定义模板", value: 1},
        {label: "平台运输模板", value: 2},
      ],
      tableList: [],
      filterName: null,
      loading: false,
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        size: "mini",
      },
      tableColumn: [
        {field: "name", title: "姓名"},
        {field: "identityType", title: "身份"},
      ], // 表格数据列
    };
  },
  watch: {
    isSubmit: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val) {
          // if (
          //   this.formData.applyTime != null &&
          //   this.formData.applyTime != ""
          // ) {
          //   this.formData.applyTime = this.$utils.timestamp(
          //     this.$utils.toStringDate(this.formData.applyTime)
          //   );
          // }
          this.$emit("payObj", this.formData);
          this.submit();
        }
      },
    },
    isLoaded: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val) {
          this.init();
        }
      },
    },
    // $route(to, from) {
    //   if (to.name === "我的请求详情" || to.name === "待我审批流程") {
    //     this.init();
    //   }
    // },
  },
  methods: {
    removeReterence() {
      this.formData.reterence = null;
      this.formData.reterenceId = null;
    },
    selectCompName(row, id, name) {
      this.formData.compName = name;
      this.formData.platformCompanyId = id;
      this.$emit('selectComp', row, id, name);
    },
    init() {
      // console.log(this.formDataObj);
      // debugger
      this.formData.compName = this.formDataObj.compName;
      this.formData.platformCompanyId = this.formDataObj.platformCompanyId;
      this.formData.instanceName = this.formDataObj.instanceName;
      this.formData.instanceNum = this.formDataObj.instanceNum;
      this.formData.applyUserName = this.formDataObj.applyUserName;
      this.formData.isQqPush = this.formDataObj.isQqPush;
      this.formData.applyTime = this.$utils.toStringDate(
          this.formDataObj.applyTime
      );
      this.formData.applyUserId = this.formDataObj.applyUserId;
      if (isNotEmpty(this.formDataObj.payType)) {
        this.formData.type = this.formDataObj.payType;
        this.formData.payType = this.formDataObj.payType;
        // debugger
      } else {
        // 权限控制
        if (this.isHavePermission("payments:createPaymentsSeller")) {
          this.formData.type = 1;
        } else {
          this.formData.type = 0;
        }
      }
      this.formData.reterence = this.formDataObj.reterenceName
          ? this.formDataObj.reterenceName
          : null;
      this.formData.reterenceId = this.formDataObj.reterenceId
          ? this.formDataObj.reterenceId
          : null;
      this.formData.leader = this.formDataObj.leaderName
          ? this.formDataObj.leaderName
          : null;
      this.formData.leaderId = this.formDataObj.leaderId
          ? this.formDataObj.leaderId
          : null;
      this.formData.manager = this.formDataObj.managerName
          ? this.formDataObj.managerName
          : null;
      this.formData.managerId = this.formDataObj.managerId
          ? this.formDataObj.managerId
          : null;
      this.formData.isLeaderEdit = this.formDataObj.isLeaderEdit;
      this.formData.isManagerEdit = this.formDataObj.isManagerEdit;
      this.formData.isReterenceEdit = this.formDataObj.isReterenceEdit;
      this.$emit("payObj", this.formData);
      // this.getAuthPermission()
      // console.log(this.isEdit, 'this.isEdit');
      // console.log(this.isChangeType, 'this.isChangeType');
      // debugger
      // if (!this.isEdit) {
      //   this.formData.reterence = this.formDataObj.reterenceName;
      //   this.formData.reterenceId = this.formDataObj.reterenceId;
      //   this.formData.leader = this.formDataObj.leaderName;
      //   this.formData.leaderId = this.formDataObj.leaderId;
      //   this.formData.manager = this.formDataObj.managerName;
      //   this.formData.managerId = this.formDataObj.managerId;
      // } else {
      //   this.formData.reterence = null;
      //   this.formData.reterenceId = null;
      //   this.formData.leader = null;
      //   this.formData.leaderId = null;
      //   this.formData.manager = null;
      //   this.formData.managerId = null;
      // }
    },
    // getAuthPermission() {
    //   if (this.isHavePermission('payments:createPaymentsSeller')) {
    //     this.formData.type = 1
    //   } else {
    //     this.formData.type = 0
    //   }
    // },
    clearValidate() {
      this.$refs.payForm.clearValidate();
    },
    async validEvent() {
      const errMap = await this.$refs.payForm
          .validate()
          .catch((errMap) => errMap);
      return errMap ? false : true;
    },
    async submit() {
      let sts = await this.validEvent();
      if (!sts) {
        this.$emit("isErrMap", false);
      } else {
        this.$emit("isErrMap", true);
      }
    },
    changeType() {
      // if (!this.isHavePermission('payments:createPaymentsSellerOnline')) {
      //   this.formData.type = 0
      //   this.$XModal.message({ message: "对不起，您无创建线上付款权限" });
      //   return
      // }
      this.$emit("payObj", this.formData);
    },
    changeContractType(value) {
      this.$emit("changeContractType", value);
    },
    focusEvent(name) {
      let refs = this.$refs[name];
      this.tablePage.currentPage = 1;
      this.filterName = "";
      this.getUserList();
      refs.showPanel();
    },
    async getUserList() {
      let res = await $api.user.request("queryUserList", {
        orderBy: 2,
        page: this.tablePage.currentPage,
        rows: this.tablePage.pageSize,
        userName: this.filterName,
      });
      if (res.status === 1) {
        this.tablePage.total = res.data.total;
        // this.tableList = res.data.rows;
        this.tableList = res.data.rows.map((item) => {
          return {
            name: item.name,
            id: item.id,
            identityType: item.identityType === 0 ? "业务员 " : "内部员工",
          };
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    search() {
      this.tablePage.currentPage = 1;
      this.getUserList();
    },
    async cellClickEvent({row}) {
      this.formData.reterence = row.name;
      this.formData.reterenceId = row.id;
      // console.log(this.formData, 'this.formData');
      // debugger
      this.$refs.xDown.hidePanel();
    },
    async cellClickEvent1({row}) {
      this.formData.manager = row.name;
      this.formData.managerId = row.id;
      this.$refs.xDown1.hidePanel();
    },
    async cellClickEvent2({row}) {
      this.formData.leader = row.name;
      this.formData.leaderId = row.id;
      this.$refs.xDown2.hidePanel();
    },
    pageChange(e) {
      this.tablePage.currentPage = e.currentPage;
      this.tablePage.pageSize = e.pageSize;
      this.getUserList();
    },
  },
};
</script>

<style>
.pcd-detail-header .vxe-form .vxe-form--item {
  padding: 0;
}

.pcd-detail-header .vxe-form .vxe-form--item:first-child .vxe-input--inner,
.pcd-detail-header
.vxe-form
.vxe-form--item:first-child
.vxe-input:not(.is--disabled).is--active
.vxe-input--inner,
.pcd-detail-header .vxe-form .vxe-form--item:first-child .vxe-form--item-title {
  /*border-bottom: none;*/
}

.pcd-detail-header
.vxe-form
.is--error.vxe-form--item:first-child
.vxe-input--inner {
  border-bottom: 1px solid #f56c6c;
}

.pcd-detail-header .vxe-form--item-title {
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  border: 1px solid #f2f1f1;
}

.pcd-detail-header .vxe-input,
.pcd-detail-header .vxe-form--item-content,
.pcd-detail-header .ivu-select {
  height: 30px;
}

.pcd-detail-header .vxe-input--inner {
  border-radius: 0;
  border: 1px solid #f2f1f1;
}

.pcd-detail-header .vxe-input:not(.is--disabled).is--active .vxe-input--inner {
  border: 1px solid #f2f1f1;
}

.pcd-detail-header .ivu-select-single .ivu-select-selection,
.pcd-detail-header .ivu-input {
  height: 30px;
  border-radius: 0px;
  border: 1px solid #f2f1f1;
  box-shadow: none;
}

.pcd-detail-header
.ivu-select-single
.ivu-select-selection
.ivu-select-selected-value,
.pcd-detail-header
.ivu-select-single
.ivu-select-selection
.ivu-select-placeholder {
  height: 30px;
  line-height: 30px;
}

.pcd-detail-header .vxe-input--inner[disabled] {
  cursor: not-allowed;
  background-color: #fff;
}

.people-dropdown-x {
  width: 400px;
  height: 300px;
  background-color: #fff;
  /* border: 1px solid #dcdfe6; */
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
}

.pcd-peo-down {
  border-bottom: 1px solid #f2f1f1;
}

.pcd-peo-down .sel-link,
.sel-link-span {
  display: block;
  width: 100%;
  height: 100%;
  line-height: 30px;
  text-indent: 10px;
}

.pcd-peo-down .table-style .vxe-header--column .vxe-cell {
  height: 32px;
  overflow: hidden;
  display: block;
  line-height: 36px;
}

.searchInput {
  position: absolute;
  right: 10px;
  top: 13px;
  z-index: 999;
  width: 200px;
}

.people-dropdown-x .table-style .vxe-header--column .vxe-cell {
  justify-content: left;
}

.pcd-detail-header .pcd-peo-down .ivu-input {
  height: 34px;
}

.pcd-detail-header .vxe-form--item.is--span .vxe-select {
  width: 75px;
}

.pcd-detail-header .vxe-form--item-valid {
  display: none;
}

.pcd-detail-header .ivu-select-disabled .ivu-select-selection {
  background-color: #fff;
  color: #606266;
}

.pay-form .vxe-form--item-inner {
  height: 30px;
  min-height: 0;
}
</style>